class CreateMapIconReq{
    constructor(){
        this.Name =  "";
        this.Image = null;
        this.Abbreviation = "";
        this.SalesOrgId = "";
    }
}
export default CreateMapIconReq;